import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import AddedTimePopupDetails from './AddedTimePopupDetails.vue'

export const AddedTimePopup = new PopupBuilder('Added Time')
  .appendBody(AddedTimePopupDetails)
  .build()
